import firebase from './firebase-dev.data'

export const environment = {
  app_name: 'Inova PTT',
  production: false,
  onpremise: false,
  baseUrl: 'https://apihomolog.biptt.net/api/v2',
  //baseUrl: 'https://api.biptt.com.br',
  webSocketUrl: 'wss://wshomolog.biptt.net',
  //webSocketUrl: 'wss://ws.biptt.com.br',
  sttUrl: 'https://notification.biptt.com.br:8082',
  imageUrl: 'https://image.biptt.com.br',
  registerUrl: 'https://biptt.com.br/signup/?utm_source=biptt-login-page&utm_medium=login&utm_campaign=login',
  identityPoolId: "us-east-2:44608e52-5a78-48d1-8fc8-eaf370a6086f",
  use_email_verification: false,
  use_rdstation: false,
  firebase: { ...firebase.firebase },
  usePhoneAuth: false,
  promoLeadUrl: 'https://materiais.biptt.com.br/landing-page-do-embaixador?bl_ref=Q05D5'
};
